import type {
  Button,
  ButtonOverlay,
  ConditionalCtaContent,
  ContentItem,
} from "./contentItemSchemas";

import {
  CTA_TYPE_BUTTON,
  CTA_TYPE_BUTTON_OVERLAY,
  CTA_TYPE_CONDITIONAL_CTA,
  isCtaSectionType,
} from "@/types/contentSectionType";

export const isButtonContentItem = (item: ContentItem): item is Button =>
  item.type === CTA_TYPE_BUTTON;

export const isButtonOverlayContentItem = (
  item: ContentItem,
): item is ButtonOverlay => item.type === CTA_TYPE_BUTTON_OVERLAY;

export const isConditionalCtaContentItem = (
  item: ContentItem,
): item is ConditionalCtaContent => item.type === CTA_TYPE_CONDITIONAL_CTA;

export const isCtaContentItem = (item: ContentItem): boolean =>
  isCtaSectionType(item.type);
